export default class RectangleEventExtensions {
  static initClass() {
    this.prototype.delay = (function() {
      let timer = 0
      return function(callback, ms) {
        clearTimeout(timer)
        timer = setTimeout(callback, ms)
      }
    })()
  }
  constructor(rectangle) {
    this.rectangle = rectangle
    let rectangleProto = this.rectangle
    let originalSetFunc = rectangleProto.set
    this.captureEvents = []
    rectangleProto.set = this.hijackedSetFunc(originalSetFunc)
  }

  hijackedSetFunc(originalSetFunc) {
    let context = this
    return function(a, b) {
      if (typeof context[a] === 'function') {
        context[a](b)
      }
      return originalSetFunc.call(this, a, b)
    }
  }

  capturing(b) {
    this.captureEvents.push(b)
    return this.delay(() => {
      let capture = this.captureEvents[this.captureEvents.length - 1]
      if ((this.previousCapture === true) && (capture === false)) {
        google.maps.event.trigger(this.rectangle, 'resized')
      }
      this.previousCapture = capture
      this.captureEvents = []
    }, 10)
  }
}
RectangleEventExtensions.initClass()



// WEBPACK FOOTER //
// ./src/components/Markup/RectangleEventExtensions.js